var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFloppyDisc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.floppy-disc-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "floppy-disc-svg",
    d: "M2.8,15.2h10.5c1.1,0,2-0.9,2-2V5.8c0-0.5-0.2-1-0.6-1.4l-3.1-3.1c-0.4-0.4-0.9-0.6-1.4-0.6H2.8 c-1.1,0-2,0.9-2,2v10.5C0.8,14.4,1.6,15.2,2.8,15.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "floppy-disc-svg",
    d: "M4.8,15v-3.2c0-0.6,0.4-1,1-1h4.5c0.6,0,1,0.4,1,1V15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "floppy-disc-svg",
    d: "M4.8,1v3.2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDisc);
export default __webpack_public_path__ + "static/media/floppy-disc.ee453d501090680f1e4babbea4459265.svg";
export { ForwardRef as ReactComponent };